'use client';

import { useState, useEffect } from 'react';

export default function SystemClock() {
  const [time, setTime] = useState<string>('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formatted = now.toISOString().replace('T', ' ').substring(0, 19);
      setTime(formatted);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col gap-1 px-2 mb-6">
      <div className="flex items-center gap-2">
        <div className="h-1 w-1 rounded-full bg-indigo-500 animate-pulse" />
        <span className="text-[8px] font-mono font-black uppercase tracking-[0.3em] text-zinc-400">
          System_Time_UTC
        </span>
      </div>
      <span className="text-[11px] font-mono text-zinc-600 dark:text-zinc-400 tabular-nums">
        {time || 'Initializing...'}
      </span>
    </div>
  );
}